"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MappingMatchTypes = void 0;
var MappingMatchTypes;
(function (MappingMatchTypes) {
    MappingMatchTypes["Contains"] = "contains";
    MappingMatchTypes["Equals"] = "equals";
    MappingMatchTypes["Regexp"] = "matches_regex";
    MappingMatchTypes["StartsWith"] = "starts_with";
    MappingMatchTypes["EndsWith"] = "ends_with";
})(MappingMatchTypes = exports.MappingMatchTypes || (exports.MappingMatchTypes = {}));
//# sourceMappingURL=mapping.match.types.js.map